export type LoginResponseType = {
  statusCode: number;
  message: string;
  success: boolean;
  userData: {
    userName: string;
    accessToken: string;
    userType: string;
    partyCode: string;
  };
};

export type FinYearDataType = {
  yearCode: string;
  startDate: string;
  endDate: string;
};

export type GetFinYearResponseType = {
  statusCode: number;
  message: string;
  success: boolean;
  finDatas: FinYearDataType[];
};

export type WCSType = {
  workContractDate: Date | null;
  clientPO: string;
  clientPODate: Date | null;
  itemName: string;
  shade: string;
  netQuantity: number;
  dispatchedBilling: number;
  balance: number;
  fabricReceiptDate: string;
  machineLoadingDate: string;
  machineUnloadingDate: string;
  finishingDate: string;
  packingDate: string;
  fobSentDate: string;
  fobApprovalDate: string;
  dispatchedDate: string;
  completionDate: Date | null;
  closedDateTime: Date | null;
  rpInwardDate: string;
  rpOutwardDate: string;
};

export const WCSLoading: WCSType[] = [
  {
    workContractDate: null,
    clientPO: "Loading...",
    clientPODate: null,
    itemName: "Loading...",
    shade: "Loading...",
    netQuantity: 0,
    dispatchedBilling: 0,
    balance: 0,
    fabricReceiptDate: "Loading...",
    machineLoadingDate: "Loading...",
    machineUnloadingDate: "Loading...",
    finishingDate: "Loading...",
    packingDate: "Loading...",
    fobSentDate: "Loading...",
    fobApprovalDate: "Loading...",
    dispatchedDate: "Loading...",
    completionDate: null,
    closedDateTime: null,
    rpInwardDate: "Loading...",
    rpOutwardDate: "Loading...",
  },
];

export type FIRType = {
  receiptNo: string;
  receiptDate: Date | null;
  partyName: string;
  challanNo: string;
  challanDate: Date | null;
  fabricType: string;
  category: string;
  fabric: string;
  orderForm: string;
  quantity: number;
  unit: string;
  shade: string;
  rate: number;
  wcNo: string;
  wcDate: Date | null;
  clientPO: string;
  marketingPerson: string;
};

export const FIRLoading: FIRType[] = [
  {
    receiptNo: "Loading...",
    receiptDate: null,
    partyName: "Loading...",
    challanNo: "Loading...",
    challanDate: null,
    fabricType: "Loading...",
    category: "Loading...",
    fabric: "Loading...",
    orderForm: "Loading...",
    quantity: 0,
    unit: "Loading...",
    shade: "Loading...",
    rate: 0,
    wcNo: "Loading...",
    wcDate: null,
    clientPO: "Loading...",
    marketingPerson: "Loading...",
  },
];

export type FORType = {
  invoiceNo: string;
  invoiceDate: Date | null;
  orderCategory: string;
  receiptNo: string;
  receiptDate: Date | null;
  partyName: string;
  wcNo: string;
  wcDate: Date | null;
  wcsNo: Number;
  clientPO: string;
  shade: string;
  orderForm: string;
  category: string;
  fabric: string;
  hsnCode: string;
  sacCode: string;
  quantity: number;
  billingQuantity: number;
  rate: number;
  unit: string;
  freightRate: number;
  packingListNo: string;
  packingListDate: Date | null;
  basicAmount: number;
  freight: number;
  otherCharges: number;
  taxableAmount: number;
  cgstRate: number;
  cgstAmount: number;
  sgstRate: number;
  sgstAmount: number;
  igstRate: number;
  igstAmount: number;
  totalAmount: number;
  fabricType: string;
};

export const FORLoading: FORType[] = [
  {
    invoiceNo: "Loading...",
    invoiceDate: null,
    orderCategory: "Loading...",
    receiptNo: "Loading...",
    receiptDate: null,
    partyName: "Loading...",
    wcNo: "Loading...",
    wcDate: null,
    wcsNo: 0,
    clientPO: "Loading...",
    shade: "Loading...",
    orderForm: "Loading...",
    category: "Loading...",
    fabric: "Loading...",
    hsnCode: "Loading...",
    sacCode: "Loading...",
    quantity: 0,
    billingQuantity: 0,
    rate: 0,
    unit: "Loading...",
    freightRate: 0,
    packingListNo: "Loading...",
    packingListDate: null,
    basicAmount: 0,
    freight: 0,
    otherCharges: 0,
    taxableAmount: 0,
    cgstRate: 0,
    cgstAmount: 0,
    sgstRate: 0,
    sgstAmount: 0,
    igstRate: 0,
    igstAmount: 0,
    totalAmount: 0,
    fabricType: "Loading...",
  },
];

export type JoStatusType = {
  statusCode: string;
  statusName: string;
  active: "Y" | "N";
};

export type JoDetailType = {
  orderNo: string;
  orderDate: Date;
  osNo: number;
  companyName: string;
  branchCode: string;
  orderCategory: string;
  category: string;
  partyName: string;
  wcNo: string;
  wcDate: Date;
  wcsNo: number;
  itemName: string;
  orderForm: string;
  packedQuantity: string;
  finishWidth: number;
  shade: string;
  hsnCode: string;
  hsnRate: number;
  processLoss: number;
  quantity: number;
  netQuantity: number;
  unitCode: string;
  rate: number;
  amount: number;
  discount: number;
  taxableAmount: number;
  cgstRate: number;
  cgstAmount: number;
  sgstRate: number;
  sgstAmount: number;
  igstRate: number;
  igstAmount: number;
  totalAmount: number;
  deliveryDate: Date;
  remarks: {
    orderNo: string;
    osNo: number;
    statusCode: string;
    remarks: string;
    systemDateTime: Date;
  }[];
  loadingImage: "Y" | "N";
  unLoadingImage: "Y" | "N";
  dyedOrPrintedImage: "Y" | "N";
  checkedOrFinishedImage: "Y" | "N";
  dispatchedImage: "Y" | "N";
  isDifferent: boolean;
  isUpdatedToday: boolean;
};

// export type JoDetailWithDivideType = {
//   orderNo: string;
//   orderDate: Date;
//   osNo: number;
//   companyName: string;
//   branchCode: string;
//   orderCategory: string;
//   category: string;
//   partyName: string;
//   wcNo: string;
//   wcDate: Date;
//   wcsNo: number;
//   itemName: string;
//   finishWidth: number;
//   shade: string;
//   hsnCode: string;
//   hsnRate: number;
//   processLoss: number;
//   quantity: number;
//   netQuantity: number;
//   unitCode: string;
//   rate: number;
//   amount: number;
//   discount: number;
//   taxableAmount: number;
//   cgstRate: number;
//   cgstAmount: number;
//   sgstRate: number;
//   sgstAmount: number;
//   igstRate: number;
//   igstAmount: number;
//   totalAmount: number;
//   deliveryDate: Date;
//   remarks: string;
//   loadingImage: "Y" | "N";
//   unLoadingImage: "Y" | "N";
//   dyedOrPrintedImage: "Y" | "N";
//   checkedOrFinishedImage: "Y" | "N";
//   dispatchedImage: "Y" | "N";
//   isDifferent: boolean;
// };
